<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="formulario" name="formulario" *ngIf="botonVisibleEditar && !verDetalle">
    <div class="grid form-group">
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "TASASVARIABLES.LBL_DIASVIGENCIA" | translate }}</label>
          <input autocomplete="false" formControlName="diasVigencia" name="diasVigencia" (input)="calcularFechaFin()"
                 id="diasVigencia" [maxlength]="3" numero-entero-reactive pInputText [minimo]="1"/>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submitted && f.diasVigencia.invalid">
            {{ "TASASVARIABLES.LBL_DIASVIGENCIA" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "TASASVARIABLES.LBL_FECHAINICIO" | translate }}</label>
          <div>
            <p-calendar id="fechaInicioVigencia" [showButtonBar]="false" name="fechaInicioVigencia" [showIcon]="true" [showTime]="false"
                        [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="{{rango}}" [minDate]="hoy"
                        [locale]="calPropiedades.informacion" [readonlyInput]="true"
                        formControlName="fechaInicioVigencia"
                        dataType="date" (onSelect)="calcularFechaFin()"
                        dateFormat="yy'-'mm'-'dd"
            >
            </p-calendar>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaInicioVigencia.invalid">
              {{ 'TASASVARIABLES.LBL_FECHAINICIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="!permitirFecha">
              {{ 'TASASVARIABLES.MSG_NOPERMITIRFECHA' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "TASASVARIABLES.LBL_FECHAFIN" | translate }}</label>
          <div>
            <p-calendar id="fechaFinVigencia" [showButtonBar]="false" name="fechaFinVigencia" [showIcon]="true" [showTime]="false"
                        [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="{{rango}}" [minDate]="hoy"
                        [locale]="calPropiedades.informacion" [readonlyInput]="true"
                        formControlName="fechaFinVigencia"
                        dataType="date" disabled="true"
                        dateFormat="yy'-'mm'-'dd"
            >
            </p-calendar>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.fechaFinVigencia.invalid">
              {{ 'TASASVARIABLES.LBL_FECHAFIN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="!permitirFecha">
              {{ 'TASASVARIABLES.MSG_NOPERMITIRFECHA' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ "TASASVARIABLES.LBL_VALORDETASA" | translate }}</label>
          <input autocomplete="false" formControlName="valorTasa" name="valorTasa"
                 id="valorTasa" [maxlength]="10" numero-decimal-reactive pInputText
                  [entero]="3" [decimales]="6"/>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submitted && f.valorTasa.invalid">
            {{ "TASASVARIABLES.LBL_VALORDETASA" | translate }}
            {{ "LBL_REQUERIDO" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{
            "BTN_CANCELAR" | translate
            }}</a>
          <button icon="fa fa-floppy-o" label="{{ 'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
          <span>{{ "LBL_GUARDANDO" | translate }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt [value]="listasasVarCon" selectionMode="single" class="table-tasaVariable"
               dataKey="idProducto" [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr [pSelectableRow]="row" [ngClass]="{'background-inactivar': row.indicadorInactivar}">
            <td class="text-center">{{row.diasVigencia}}</td>
            <td class="text-center">{{row.fechaInicioVigencia | date:'dd/MM/yyyy'}}</td>
            <td class="text-center">{{row.fechaFinVigencia | date:'dd/MM/yyyy'}}</td>
            <td class="text-center">{{row.valorTasa}}</td>
            <td class="text-center">{{row.estado}}</td>
            <td class="text-center">{{row.usuarioConfigura}}</td>
            <td class="text-center">{{row.usuarioAprueba}}</td>
            <td class="text-center">{{row.fechaCreacion | date:'dd/MM/yyyy HH:mm'}}</td>
            <td class="text-center">{{row.fechaAprobacion | date:'dd/MM/yyyy HH:mm'}}</td>
            <td pTooltip="{{ row.observacion }}" tooltipPosition="top" class="text-center">
              <div *ngIf="row.observacion">
                {{ row.observacion.length>50 ? (row.observacion | slice:0:50)+"..." : row.observacion}}
              </div>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-ban" data-toggle="tooltip" *ngIf="botonVisibleEditar && !verDetalle && !row.indicadorInactivar && (row.codigoEstado === estadosTasasVaraibles.CNFACT || row.codigoEstado === estadosTasasVaraibles.CNFAPR)"
                        title="{{'TASASVARIABLES.BTN_INACTIVAR' | translate}}" (click)="activarModalTasas(row)" pButton></button>
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip" *ngIf="botonVisibleEditar && row.codigoEstado === estadosTasasVaraibles.CNFPEN && !verDetalle"
                        title="{{'BTN_EDITAR' | translate}}" (click)="editar(row, rowIndex)" pButton></button>
                <button type="button" class="p-button btn" data-toggle="tooltip" *ngIf="botonVisibleAprobar && !verDetalle && (row.codigoEstado==='CNFPEN' || row.indicadorInactivar)"
                        title="{{'TASASVARIABLES.BTN_APROBAR' | translate}}" icon="fa fa-shield" (click)="aprobarDenegarTasa(row)" pButton>
                </button>
                <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                        title="{{'BTN_VISUALIZAR' | translate}}" pButton (click)="visualizar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons" *ngIf="verDetalle">
    <div class="form-group col-12">
      <a (click)="regresar(false)" class="cancelar">{{
        "LBL_SALIR" | translate
        }}</a>
    </div>
  </div>
</div>

<p-dialog [positionTop]="60"
          [(visible)]="showModalAprobacion"
          [contentStyle]="{'width':'600px'}"

          [closable]="modalClose"
          [closeOnEscape]="modalClose"
          appendTo="body"
          [modal]="true">
  <p-header class="header-modal">
    <label>{{_dataTasaVariables?.titulo}}</label>
  </p-header>
  <app-loading [hidden]="!loadingModal"></app-loading>
  <div class="grid" *ngIf="!loadingModal">
    <div class="lg:col-12 md:col-12 col-12 display-flex justify-content" style="padding: 0px;">
      <img src="../../../assets/icons/alerta-tasa.svg" alt="alerta" width="60" height="60"
      />
    </div>
  </div>
  <ng-container *ngIf="_dataTasaVariables && !_dataTasaVariables?.indicadorInactivar && !loadingModal">
    <form [formGroup]="formularioCambioEstado" (ngSubmit)="onSubmitCambioEstado()" novalidate id="formularioEstado" name="formularioEstado">
      <div class="grid">
        <div class="lg:col-12 md:col-12 col-12 display-flex justify-content texto-confirmacion" >
          <label>{{'TASASVARIABLES.LBL_CONFIRMACIONINACTIVAR' | translate}}</label>
        </div>
        <div class="lg:col-12 md:col-12 col-12 display-flex justify-content texto-confirmacion" >
          <label>{{'TASASVARIABLES.LBL_INFORMACION' | translate}}</label>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="col-12">
            <div class="div-form">
              <label><strong>{{ 'TASASVARIABLES.LBL_OBSERVACIONES' | translate}} :</strong></label>
              <textarea type="text" pInputText id="observacion"
                        name="observacion" maxlength="500"
                        formControlName="observacion"
                        autocomplete="off" capitalize-reactive></textarea>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submittedEstado && e.observacion.invalid">
                {{ 'TASASVARIABLES.LBL_OBSERVACIONES' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submittedEstado  && numeroCaracteres">
                {{ 'TASASVARIABLES.LBL_FALTAINFOR' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-close" label="{{ 'BTN_CANCELAR' | translate }}" type="button"
                  pButton (click)="cerrarModalEstados()" style="background: red; margin: 20px"></button>
          <button icon="fa fa-floppy-o" label="{{ 'BTN_ACEPTAR' | translate }}" type="submit" pButton></button>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="_dataTasaVariables && _dataTasaVariables?.indicadorInactivar && !loadingModal">
    <div class="grid">
      <label class="lg:col-12 col-12 md:col-12 display-flex justify-content texto-confirmacion">{{'TASASVARIABLES.LBL_INACTIVARTASA' | translate}}</label>
      <label class="lg:col-3 col-3 md:col-3"><strong>{{'TASASVARIABLES.LBL_NOMBREDETASA' | translate}}</strong></label>
      <label class="lg:col-3 col-3 md:col-3">{{_dataTasaVariables?.tasaVariable}}</label>
      <label class="lg:col-3 col-3 md:col-3 control-label"><strong>{{'TASASVARIABLES.LBL_PERIODICIDAD' | translate}}</strong></label>
      <label class="lg:col-3 col-3 md:col-3">{{_dataTasaVariables?.diasVigencia}}</label>
      <label class="lg:col-3 col-3 md:col-3 control-label"><strong>{{'TASASVARIABLES.LBL_FECHAINICIO' | translate}}</strong></label>
      <label class="lg:col-3 col-3 md:col-3">{{_dataTasaVariables?.fechaInicioVigencia | date:'dd/MM/yyyy'}}</label>
      <label class="lg:col-3 col-3 md:col-3 control-label"><strong>{{'TASASVARIABLES.LBL_FECHAFIN' | translate}}</strong></label>
      <label class="lg:col-3 col-3 md:col-3">{{_dataTasaVariables?.fechaFinVigencia | date:'dd/MM/yyyy'}}</label>
      <label class="lg:col-3 col-3 md:col-3 control-label"><strong>{{'TASASVARIABLES.LBL_VALORTASA' | translate}}</strong></label>
      <label class="lg:col-9 col-9 md:col-9">{{_dataTasaVariables?.valorTasa}}</label>
      <label class="lg:col-3 col-3 md:col-3 control-label"><strong>{{'TASASVARIABLES.LBL_DESCRIPCION' | translate}}</strong></label>
      <label class="lg:col-9 col-9 md:col-9">{{_dataTasaVariables?.observacion}}</label>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-ban" label="{{ 'TASASVARIABLES.BTN_RECHAZAR' | translate }}" type="button"
                pButton (click)="cambioEstadoTasa(false)" style="background: red; margin: 20px"></button>
        <button icon="fa fa-check" label="{{ 'TASASVARIABLES.BTN_INACTIVAR' | translate }}" type="button" (click)="cambioEstadoTasa(true)" pButton></button>
      </div>
    </div>
  </ng-container>
</p-dialog>
